/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import { MSALInstanceFactory, MSALInterceptorConfigFactory, MSALGuardConfigFactory, loggerCallback } from './app/app.module';
import { importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { AppComponent } from './app/app.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { DashboardProvidersModule } from './app/dashboard/dashboard-providers.module';
import { CoreModule } from './app/core/core.module';
import { StartupFeatureProvidersModule } from './app/startup-feature-providers.module';
import { AppRoutingModule } from './app/app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { VersionCheckService } from './app/core/version-check.service';
import { MsalInterceptor, MSAL_INSTANCE, MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG, MsalService, MsalGuard, MsalBroadcastService, MsalModule } from '@azure/msal-angular';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient, withXhr } from '@angular/common/http';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { ErrorInterceptor } from './app/core/interceptors/error.interceptor';
import { MatNativeDateModule } from '@angular/material/core';
import { TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    // Keep overlays in the existing z-index stack rather than the browser's top layer.
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    // The wrapper loads this self-hosted runtime only when the first editor is created.
    { provide: TINYMCE_SCRIPT_SRC, useValue: '/tinymce/tinymce.min.js' },
    importProvidersFrom(
      // BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
      FormsModule,
      ReactiveFormsModule,
      AppRoutingModule,
      // https://angular.io/guide/router#module-import-order-matters
      MsalModule,
      StartupFeatureProvidersModule,
      CoreModule,
      DashboardProvidersModule,
      MatSidenavModule,
      MatSnackBarModule,
      MatMomentDateModule, // asset dashboard wasn't working until I added these two lines
      MatNativeDateModule
    ),
    // Registered ahead of MsalInterceptor so it sits outside it on the response path: MSAL handles
    // a token failure first, and this only alerts for what survives.
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    provideAppInitializer(() => inject(MSAL_INSTANCE).initialize()),
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    VersionCheckService,
    provideAnimations(),
    provideHttpClient(withXhr(), withInterceptorsFromDi())
  ]
})
  .catch(err => console.log(err));
